import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-brand-accent text-white py-2 px-4 text-center text-sm font-medium shadow-md" data-id="element-226">
      ⏳ Oferta especial de lanzamiento: Solo $8,99 — Acceso inmediato
    </div>;
}